import { BusinessPartnerContext } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 0440. 取引先種別一覧
 * [GET] /business_partner_contexts
 */
const businessPartnerContexts = (): Promise<BusinessPartnerContext[]> => {
  return axios.get(`/api/business_partner_contexts`);
};

export const useBusinessPartnerContexts = () => {
  return useQuery({
    queryKey: ['business_partner_contexts'],
    queryFn: () => businessPartnerContexts(),
  });
};